<template>
  <div class="confetti-input">
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label
      class="confetti-input-container"
      :class="{ 'confetti-input-error': isError }"
    >
      <slot name="icon" />
      <input
        :value="value"
        class="confetti-input-input"
        :disabled="isDisabled"
        :name="name || label"
        :max="max"
        :min="min"
        :required="isRequired"
        :type="type"
        @blur="$emit('blur', $event.target.value)"
        @input="$emit('input', $event.target.value)"
        @keypress="handleKeypress"
        @keydown.enter="$emit('enter', $event.target.value)"
      />
      <span class="confetti-input-label">{{ label }}</span>
    </label>
    <div v-if="isError" class="confetti-input-error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfettiInput",
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
    min: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
    },
    isRequired: {
      type: Boolean,
    },
    isError: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    onlyInteger: {
      type: Boolean,
    },
  },
  methods: {
    handleKeypress($event) {
      if (this.onlyInteger) {
        if ($event.code === "Comma" || $event.code === "Period") {
          $event.preventDefault();

          return;
        }
      }

      this.$emit("keypress", $event.target.value);
    },
  },
};
</script>
